import styled from "styled-components"
import theme from "../../styles/theme"

export default styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  background-color: ${theme.color.indigo100};
  border-radius: 1rem;
  padding: 4rem;
  align-items: center;
  .klipfolio-image-wrapper {
    margin: 0 auto;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    height: min-content;
    align-items: center;
    overflow: visible;
    div {
      height: min-content;
      box-shadow: ${theme.shadow.dramatic};
    }
    img {
      max-height: 400px;
      object-fit: scale-down !important;
    }
  }
`
